import React, { useState } from "react";
import { SortByProps } from "@usereactify/search";
import { SortByDesktop } from "./SortByDesktop";
import { SortByMobile } from "./SortByMobile";
import { chevronDown } from "../../react-hooks/svgIcons";
import { isMobile } from '../../react-hooks/Utilties';

export type SortBySelectorProps = React.ComponentProps<
    NonNullable<SortByProps["render"]>
>

export const SortBySelector: React.FC<SortBySelectorProps> = ({ ...props }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(props.sortOption);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleOptionSelect = (handle: string) => {
        const selected = props.sortOptions.find(
            (option) => option.handle === handle
        );
        if (selected) {
            setSelectedOption(selected);
            props.setSortOption(handle);
        }
        setIsOpen(false);
    };


    return (
        <div className="relative">
            <span className="rs__sortby__button flex justify-center align-center uppercase gap-2" onClick={toggleDropdown}>
                <span>{"Sort By"}</span>
                {chevronDown}
            </span>


            <SortByDesktop {...props} isOpen={isOpen} handleOptionSelect={handleOptionSelect} selectedOption={selectedOption} />


        </div>
    );
};
